import { FC } from "react";
import BemIt from "@gtechdoodler/bem-it";

import { CarouselArrowProps } from "./CarouselArrow.types";
import { StyledCarouselArrow } from "./CarouselArrow.styles";

const CarouselArrow: FC<CarouselArrowProps> = ({
	className,
	direction = "prev",
	slidesToShow,
	onClick,
	...props
}) => {
	const { currentSlide, slideCount } = props;

	const block = new BemIt("CarouselArrow");

	const isMultipleSlides = slidesToShow > 1;
	const colorOn = isMultipleSlides ? "bg_light" : "bg_dark";
	const icon = direction === "next" ? "arrow-right" : "arrow-left";

	const nextDisabled = Boolean(
		slideCount && currentSlide === slideCount - slidesToShow
	);
	const prevDisabled = currentSlide === 0;

	const disabled = direction === "next" ? nextDisabled : prevDisabled;

	return (
		<StyledCarouselArrow
			className={block.mod(direction).out}
			colorOn={colorOn}
			direction={direction}
			icon={icon}
			slidesToShow={slidesToShow}
			disabled={disabled}
			onClick={onClick}
		/>
	);
};

export default CarouselArrow;
